import React from 'react'
import { search } from '../actions/filter/search.js'

export const MechanismsHOC = ComposedComponent => class extends React.Component {
  static displayName = 'ComponentMechanismsHOC';

  componentDidMount () {

    if (this.props.initialMechanisms.length === 0)
      setTimeout(() => {search(`/transformation_mechanisms`, this.props.initialGoods, this.props)}, 10)
  }

  render () {
    return <ComposedComponent {...this.props} {...this.state} />;
  }
}